<script setup lang="ts">
withDefaults(defineProps<{ badges?: string[] }>(), {
    badges: () => ['100% Free', 'No Signup Required', 'No Obligation', 'AI Powered', 'Privacy Focused'],
})
</script>

<template>
    <div class="trust-badges">
        <span v-for="badge in badges" :key="badge" class="badge">✓ {{ badge }}</span>
    </div>
</template>

<style scoped lang="scss">
.trust-badges {
    display: flex;
    flex-wrap: wrap;
    gap: var(--site-space-sm);
}
</style>
